import React, { FC } from "react";
import { cn } from "@/lib/utils";
import { useDashboardQrMetrics } from "../hooks/useDashboardQrMetrics";

interface Props {
  className?: string;
}

/** Rapid replacement of the Activity Log: QR entries and service orders, zeros included. */
export const DashboardQrMetrics: FC<Props> = ({ className }) => {
  const { metrics, isLoading, isError } = useDashboardQrMetrics(true);

  if (isError) {
    return (
      <p className="text-monochrome-core-2/75 text-xs">
        Metrics are unavailable. Try again later.
      </p>
    );
  }

  const items = [
    { label: "QR entries", value: metrics?.qrEntries },
    { label: "Service orders", value: metrics?.serviceOrders },
  ];

  return (
    <div
      className={cn(
        "flex min-h-0 flex-1 flex-row gap-8 overflow-visible",
        className,
      )}
      aria-busy={isLoading}
    >
      {items.map((item) => (
        <div key={item.label} className="flex flex-col gap-0.5">
          <span className="text-monochrome-core-2 text-xs leading-normal font-normal">
            {item.label}
          </span>
          <span className="text-monochrome-core-2/75 text-2xl leading-normal font-semibold">
            {isLoading ? "—" : (item.value ?? 0)}
          </span>
        </div>
      ))}
      <span className="sr-only">Last 30 days</span>
    </div>
  );
};
